namespace OptionConst {

  export const GENDER_TYPE = [
    { val: 1, label: "男性" }, 
    { val: 2, label: "女性" }
  ]

  export const DRIVERS_LICENSE = [
    { val: 0, label: "なし" }, 
    { val: 1, label: "あり" }
  ]

  export const WEB_MEISAI_FIX_TYPE = [
    { val: 0, label: "未対応" }, 
    { val: 1, label: "対応" }
  ]

  export const KINMU_STATUS_TYPE = [
    { val: 1, label: "入社" }, 
    { val: 2, label: "産休中" },
    { val: 3, label: "育休中" },
    { val: 4, label: "休職" },
    { val: 9, label: "退職" },
  ]

  // 本来1から始めたいが、ある時期までKINMU_STATUS_TYPEと共有していたため、
  // 既存データへの影響を考慮して2からスタートとしている（24.4.4 大塚）
  export const SONOTA_KYUUJITSU_TYPE = [
    { val: 2, label: "産休" },
    { val: 3, label: "育休" },
    { val: 4, label: "休職" },
  ]
}

export default OptionConst